import * as React from 'react';
import { useInView } from 'react-intersection-observer';

interface LazyMountProps {
    outerRef?: React.RefObject<HTMLDivElement | null>;
    minHeight?: number;
    rootMargin?: string;
    children: React.ReactNode;
}

export const LazyMount: React.FC<LazyMountProps> = ({
    outerRef,
    minHeight = 400,
    rootMargin = '1500px 0px',
    children
}) => {
    const { ref: inViewRef, inView } = useInView({ rootMargin, triggerOnce: true });

    const setRef = React.useCallback(
        (node: HTMLDivElement | null) => {
            inViewRef(node);
            if (outerRef) {
                outerRef.current = node;
            }
        },
        [inViewRef, outerRef]
    );

    return (
        <div ref={setRef} style={inView ? undefined : { minHeight }}>
            {inView ? children : null}
        </div>
    );
};
